import { Sort } from '@src/types/graphql-types'

export function sortTable<T extends any[]>(
  sortBy: [Sort, string],
  language: string,
  data: T
): T {
  if (!sortBy) return data
  const [sort, sortField] = sortBy
  const directionModifier = sort === Sort.Nameasc ? 1 : -1
  let sorteeA
  let sorteeB

  return data.slice().sort((data1, data2) => {
    const sortNumbers =
      typeof data1[sortField] === 'number' ||
      typeof data2[sortField] === 'number'

    if (!sortNumbers) {
      sorteeA = data1[sortField]
        ? data1[sortField].toString().trim().toLowerCase()
        : ''
      sorteeB = data2[sortField]
        ? data2[sortField].toString().trim().toLowerCase()
        : ''
    }
    try {
      if (!sortNumbers) {
        return (
          sorteeA.localeCompare(sorteeB, language, { sensitivity: 'base' }) *
          directionModifier
        )
      }
      return data1[sortField] > data2[sortField]
        ? 1 * directionModifier
        : -1 * directionModifier
    } catch (e) {
      return 0
    }
  }) as T
}
